<div id="loader-container" *ngIf="loading">
    <div class="loader" fxLayout="row" fxLayoutAlign="center center">
        <div>
            <img src="../../../../assets/images/aap-preloader.gif" alt="">
        </div>
    </div>
</div>
